import { render, staticRenderFns } from "./status-bar-item.vue?vue&type=template&id=31544a5c&"
import script from "./status-bar-item.vue?vue&type=script&lang=js&"
export * from "./status-bar-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports